//update draft code
import { updateCARRecord } from "../../../utils/updateCARRecord";
import { useState, useEffect, useMemo, useRef, useCallback } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Stack,
  Tooltip,
  Fade,
} from "@mui/material";
import {
  fetchCRMAccounts,
  filterAccountsBySearchTerm,
  registerAccountsLoadingHandler,
  searchAccountsByName,
} from "../../../api/CRMAccountsData";
import BackWithArrow from "../../common/BackWithArrow";
import { fetchEmployees } from "../../../api/employeeUtils";
import GlobalButton from "../../common/GlobalButton";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { fetchSONames, filterSOsBySearchTerm } from "../../../api/FetchWOName";
import Loader from "../../common/Loader";
import { fetchMachines } from "../../../api/GETallMachines";

export default function UpdateCAR({
  open,
  onClose = () => {},
  record,
  fetchCARData = () => {},
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({});

  // CRM Accounts data state
  const [accounts, setAccounts] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingAccounts, setIsLoadingAccounts] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);

  // Machines data state
  const [loading, setLoading] = useState(true);
  const [machines, setMachines] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState("");

  // SO data state
  const [soData, setSOData] = useState([]);
  const [loadingSO, setLoadingSO] = useState(false);
  const [searchTermso, setSearchTermso] = useState("");
  const [selectedSO, setSelectedSO] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const autocompleteRef = useRef(null);

  // Employee data state
  const [employees, setEmployees] = useState([]);
  const [qualityOwner, setQualityOwner] = useState("");
  const [qualityOwner1, setQualityOwner1] = useState("");
  const [error, setError] = useState({});
  const [submitting, setSubmitting] = useState(false);

  //
  // Create a helper function to convert date formats
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";

    try {
      // Parse the date string (e.g., "28-May-2025")
      const parts = dateString.split("-");
      if (parts.length !== 3) return "";

      const day = parts[0];
      const monthName = parts[1];
      const year = parts[2];

      // Map month names to numbers
      const months = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
      };

      const month = months[monthName];
      if (!month) return "";

      // Format as YYYY-MM-DD
      return `${year}-${month}-${day.padStart(2, "0")}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  // Initialize form data from record
  useEffect(() => {
    if (record) {
      // Initialize the form data from the record
      const initialFormData = {
        name: record.name || record.CAR_Name || "",
        date: formatDateForInput(record.date || record.CAR_Date || ""),
        Reported_By: record.CAR_Reported_By || "",
        Describe_the_issue_or_problem_in_detail:
          record.Describe_the_issue_or_problem_in_detail || "",
        assignedTo: record.CAR_PAR_Assigned_to || record.assignedTo || "",
        AssignedDate: formatDateForInput(record.Date_Assigned || ""),
        respondBy: formatDateForInput(
          record.Respond_by || record.respondBy || ""
        ),
        containment: record.Containment_Immediate_Corrections || "",
        rootCause: record.Root_cause_of_Problem || "",
        actionPlan: record.Action_Plan || "",
        actionCompleted: formatDateForInput(record.Date_Action_Completed || ""),
        Assignee_Name: record.Assignee_Name || "",
        verifiedDate: formatDateForInput(record.Verified_Date || ""),
        notes: record.Notes || "",
      };

      // Set type based on checkboxes
      if (record.Corrective_action === "true")
        initialFormData.type = "corrective";
      else if (record.Preventive_action_potential_issue === "true")
        initialFormData.type = "preventive";
      else if (record.Opportunity_for_Improvement_suggestion === "true")
        initialFormData.type = "improvement";

      // Set Source based on checkboxes
      if (record.Employee_Source_Creator === "true")
        initialFormData.Source = "Employeecheckbox";
      else if (record.CustomerSourceCreator === "true")
        initialFormData.Source = "CustomerSource";
      else if (record.ExternalAuditFindingCreator === "true")
        initialFormData.Source = "ExternalAuditFinding";
      else if (record.InternalAuditFindingCreator === "true")
        initialFormData.Source = "InternalAuditFinding";
      else if (record.SupplierSourceCreator === "true")
        initialFormData.Source = "SupplierSource";
      else if (record.ManagementReviewCreator === "true")
        initialFormData.Source = "ManagementReview";
      else if (record.OtherSourceCreator === "true")
        initialFormData.Source = "OtherSource";

      // Set Process based on checkboxes
      if (record.EstimatingSchedulingArtCreator === "true")
        initialFormData.Process = "EstimatingSchedulingArt";
      else if (record.PrintingFinishingCreator === "true")
        initialFormData.Process = "PrintingFinishing";
      else if (record.PurchasingReceivingShippingCreator === "true")
        initialFormData.Process = "PurchasingReceivingShipping";
      else if (record.InstallationSourceCreator === "true")
        initialFormData.Process = "InstallationSource";
      else if (record.OtherprocessCreator === "true")
        initialFormData.Process = "Otherprocess";

      // Set Priority based on checkboxes
      if (record.LowPriorityCreator === "true")
        initialFormData.Priority = "LowPriority";
      else if (record.MediumPriorityCreator === "true")
        initialFormData.Priority = "MediumPriority";
      else if (record.HighPriorityCreator === "true")
        initialFormData.Priority = "HighPriority";
      else if (record.UrgentCriticalCreator === "true")
        initialFormData.Priority = "UrgentCritical";

      // Set Result based on checkboxes
      if (record.PassCreator === "true") initialFormData.Result = "PassResult";
      else if (record.FailCreator === "true")
        initialFormData.Result = "FailResult";

      // Set selected objects
      if (record.Machine && record.Machine.ID) {
        setSelectedMachine(record.Machine.ID);
      }

      if (record.Employee && record.Employee.ID) {
        setQualityOwner(record.Employee.ID);
      }

      if (record.Verified_by && record.Verified_by.ID) {
        setQualityOwner1(record.Verified_by.ID);
      }

      if (record.CRM_Account_Name_CAR) {
        setSelectedAccount({
          id: record.CRM_Account_Name_CAR.ID,
          name:
            record.CRM_Account_Name_CAR.account_name ||
            record.CRM_Account_Name_CAR.zc_display_value,
        });
      }

      if (record.Job_name) {
        setSelectedSO({
          id: record.Job_name.ID,
          name: record.Job_name.SO_name || record.Job_name.zc_display_value,
        });
      }

      setFormData(initialFormData);
    }
  }, [record]);

  // Handle form field changes
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // Load CRM Accounts
  useEffect(() => {
    const unregister = registerAccountsLoadingHandler((isLoading) => {
      setIsLoadingAccounts(isLoading);
    });

    const loadAccounts = async () => {
      try {
        const initialAccounts = await fetchCRMAccounts();
        setAccounts(initialAccounts);
        setFilteredAccounts(initialAccounts);
      } catch (error) {
        console.error("Error loading accounts:", error);
      } finally {
        setLoading(false);
      }
    };

    loadAccounts();

    return () => {
      unregister();
      if (searchTimeout) clearTimeout(searchTimeout);
    };
  }, []);

  // Debounced search for accounts
  const debouncedSearch = useCallback(
    (term) => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      if (!term || term.length < 2) {
        setFilteredAccounts(accounts);
        return;
      }

      const timeoutId = setTimeout(async () => {
        setIsLoadingAccounts(true);
        try {
          const results = await searchAccountsByName(term);
          setFilteredAccounts(results);
        } catch (error) {
          console.error("Error searching accounts:", error);
          const filtered = filterAccountsBySearchTerm(accounts, term);
          setFilteredAccounts(filtered);
        } finally {
          setIsLoadingAccounts(false);
        }
      }, 500);

      setSearchTimeout(timeoutId);
    },
    [accounts, searchTimeout]
  );

  // Handle account search
  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    debouncedSearch(term);
  };

  // Handle account selection
  const handleAccountChange = (event, newValue) => {
    setSelectedAccount(newValue);
    if (newValue && newValue.id) {
      window.selectedAccountId = newValue.id;
      window.selectedAccountName = newValue.name || "";
    } else {
      window.selectedAccountId = null;
      window.selectedAccountName = "";
    }
  };

  // Handle account input change
  const handleInputChangeAccount = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  // Load machines
  useEffect(() => {
    const loadMachines = async () => {
      setLoading(true);
      try {
        const machinesData = await fetchMachines();
        setMachines(machinesData);
      } catch (error) {
        console.error("Error loading machines:", error);
      } finally {
        setLoading(false);
      }
    };

    loadMachines();
  }, []);

  // Handle machine selection
  const handleMachineChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedMachine(selectedValue);
  };

  // Load SO data
  useEffect(() => {
    const loadSOData = async () => {
      setLoadingSO(true);
      try {
        const data = await fetchSONames();
        setSOData(data);
      } catch (error) {
        console.error("Error loading SO data:", error);
      } finally {
        setLoadingSO(false);
        setLoading(false);
      }
    };

    loadSOData();
  }, []);

  // Filter SO data based on search term
  const filteredSOData = useMemo(() => {
    return filterSOsBySearchTerm(soData, searchTermso);
  }, [soData, searchTermso]);

  // Handle SO selection
  const handleSOSelection = (event, value) => {
    setSelectedSO(value);
  };

  // Custom function to display the selected value in the input
  const getOptionLabel = (option) => {
    // For dropdown options, show full details
    if (option && option.name) {
      return option.name; // Only show name for the selected value in input field
    }
    return "";
  };

  // Load employees
  useEffect(() => {
    const loadData = async () => {
      try {
        const employeeData = await fetchEmployees();
        setEmployees(employeeData || []);
      } catch (error) {
        console.error("Failed to load employees:", error);
      }
    };

    loadData();
  }, []);

  // Handle form submission
  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      setSubmitting(true);
      setError({});

      // Add quality owner to form data before submission
      const updatedFormData = {
        ...formData,
        qualityOwner: qualityOwner,
        qualityOwner1: qualityOwner1,
        // Also include account and selection information
        accountId: selectedAccount?.id || "",
        soIdPalyoad: selectedSO?.id || "",
        MachineID: selectedMachine,
        // Pass the selected objects directly to the update function
        selectedAccount: selectedAccount,
        selectedSO: selectedSO,
      };

      console.log("Submitting update with data:", updatedFormData);

      // Only send fields that have been modified
      const response = await updateCARRecord(
        record.id || record.ID,
        updatedFormData
      );

      if (response) {
        await fetchCARData(); // Refresh the cards
        onClose(); // Close the dialog
      }
    } catch (error) {
      console.error("Failed to update record:", error);
      // Show more specific error message
      alert(`Error updating CAR record: ${error.message || "Unknown error"}`);
    } finally {
      setIsSubmitting(false);
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      fullScreen
      PaperProps={{
        sx: {
          minHeight: "100vh",
          maxHeight: "100vh",
          background: "white",
        },
      }}
    >
      <BackWithArrow onBack={onClose} title="Update CAR" />
      <DialogContent dividers sx={{ maxHeight: "100vh", overflowY: "auto" }}>
        <Box display="grid" gap={2}>
          <Box
            display="grid"
            gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))"
            gap={2}
          >
            <TextField
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              label="CAR Name"
              size="small"
              fullWidth
              value={formData.name || ""}
              onChange={(e) => handleInputChange("name", e.target.value)}
            />
            <TextField
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              type="date"
              label="Date"
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={formData.date || ""}
              onChange={(e) => handleInputChange("date", e.target.value)}
            />

            <Autocomplete
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              id="account-search"
              options={filteredAccounts}
              getOptionLabel={(option) => option.name || ""}
              onChange={handleAccountChange}
              onInputChange={handleInputChangeAccount}
              inputValue={inputValue}
              value={selectedAccount}
              loading={isLoadingAccounts}
              fullWidth
              filterOptions={(options, state) => options}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search Customer Name"
                  size="small"
                  variant="outlined"
                  onChange={handleSearchChange}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {isLoadingAccounts ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Box>

          <Box
            display="grid"
            gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))"
            gap={2}
          >
            <FormControl
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              fullWidth
              size="small"
              error={!!error.qualityOwner}
            >
              <InputLabel>Employee</InputLabel>
              <Select
                value={qualityOwner || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setQualityOwner(value);
                  handleInputChange("qualityOwner", value);
                }}
                label="Quality Owner"
              >
                <MenuItem value="" disabled>
                  Select User
                </MenuItem>
                {employees && employees.length > 0 ? (
                  employees.map((employee) => (
                    <MenuItem key={employee.ID} value={employee.ID}>
                      {employee.Name.zc_display_value}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    No User Found
                  </MenuItem>
                )}
              </Select>
              {error.qualityOwner && (
                <Typography variant="caption" color="error">
                  {error.qualityOwner}
                </Typography>
              )}
            </FormControl>

            <FormControl
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              fullWidth
              size="small"
            >
              <InputLabel id="lookup-label">CAR Reported By</InputLabel>
              <Select
                labelId="lookup-label"
                id="lookup-select"
                value={formData.Reported_By || ""}
                label="CAR Reported By"
                onChange={(e) =>
                  handleInputChange("Reported_By", e.target.value)
                }
              >
                <MenuItem value="Reported by customer">
                  Reported by customer
                </MenuItem>
                <MenuItem value="Reported internally">
                  Reported internally
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              fullWidth
              size="small"
            >
              <InputLabel id="machine-select-label">Select Machine</InputLabel>
              <Select
                labelId="machine-select-label"
                id="machine-select"
                value={selectedMachine}
                label="Select Machine"
                onChange={handleMachineChange}
              >
                {machines.map((machine) => (
                  <MenuItem key={machine.id} value={machine.id}>
                    {machine.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box
            display="grid"
            gap={2}
            sx={{ minWidth: "440px", maxWidth: "250px" }}
          >
            <Tooltip
              fullWidth
              size="small"
              open={showTooltip && selectedSO !== null}
              placement="top-start"
              arrow
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <Autocomplete
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#d3d3d3",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#4F46E5",
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#4F46E5",
                  },
                }}
                ref={autocompleteRef}
                id="so-search"
                options={filteredSOData}
                getOptionLabel={getOptionLabel}
                filterOptions={(options, state) => {
                  return filterSOsBySearchTerm(options, state.inputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Job name From SO"
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingSO ? (
                            <CircularProgress color="inherit" size={10} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Stack direction="column" spacing={0.5}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="body1" fontWeight="bold">
                          {option.number}
                        </Typography>
                      </Stack>
                      <Typography variant="body2">
                        Job Name: {option.name}
                      </Typography>
                    </Stack>
                  </li>
                )}
                loading={loadingSO}
                value={selectedSO}
                onChange={handleSOSelection}
                onInputChange={(event, newInputValue) => {
                  setSearchTermso(newInputValue);
                }}
              />
            </Tooltip>
          </Box>

          {/* Type Section Checkboxes */}
          <Box display="flex" flexGrow={1}>
            <Box mr={5.3}>
              <Typography fontWeight="bold" lineHeight={2}>
                Type:
              </Typography>
              <Typography variant="body2">Check One</Typography>
            </Box>
            <Box
              display="grid"
              gridTemplateColumns="repeat(4, 1fr)"
              flexGrow={1}
            >
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.type === "corrective"}
                      onChange={() =>
                        handleInputChange(
                          "type",
                          formData.type === "corrective" ? "" : "corrective"
                        )
                      }
                    />
                  }
                  label="Corrective action (existing issue)"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.type === "improvement"}
                      onChange={() =>
                        handleInputChange(
                          "type",
                          formData.type === "improvement" ? "" : "improvement"
                        )
                      }
                    />
                  }
                  label="Opportunity for Improvement / suggestion"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.type === "preventive"}
                      onChange={() =>
                        handleInputChange(
                          "type",
                          formData.type === "preventive" ? "" : "preventive"
                        )
                      }
                    />
                  }
                  label="Preventive action (potential issue)"
                />
              </Box>
            </Box>
          </Box>

          {/* Source Section checkboxes */}
          <Box display="flex" flexGrow={1}>
            <Box mr={4}>
              <Typography fontWeight="bold" lineHeight={2}>
                Source:
              </Typography>
              <Typography variant="body2">Check One</Typography>
            </Box>
            <Box
              display="grid"
              gridTemplateColumns="repeat(4, 1fr)"
              gap={2}
              flexGrow={1}
            >
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Source === "Employeecheckbox"}
                      onChange={() =>
                        handleInputChange(
                          "Source",
                          formData.Source === "Employeecheckbox"
                            ? ""
                            : "Employeecheckbox"
                        )
                      }
                    />
                  }
                  label="Employee"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Source === "CustomerSource"}
                      onChange={(e) =>
                        handleInputChange(
                          "Source",
                          formData.Source === "CustomerSource"
                            ? ""
                            : "CustomerSource"
                        )
                      }
                    />
                  }
                  label="Customer"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Source === "ExternalAuditFinding"}
                      onChange={(e) =>
                        handleInputChange(
                          "Source",
                          formData.Source === "ExternalAuditFinding"
                            ? ""
                            : "ExternalAuditFinding"
                        )
                      }
                    />
                  }
                  label="External Audit Finding"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Source === "InternalAuditFinding"}
                      onChange={(e) =>
                        handleInputChange(
                          "Source",
                          formData.Source === "InternalAuditFinding"
                            ? ""
                            : "InternalAuditFinding"
                        )
                      }
                    />
                  }
                  label="Internal Audit Finding"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Source === "SupplierSource"}
                      onChange={(e) =>
                        handleInputChange(
                          "Source",
                          formData.Source === "SupplierSource"
                            ? ""
                            : "SupplierSource"
                        )
                      }
                    />
                  }
                  label="Supplier / Subcontractor"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Source === "ManagementReview"}
                      onChange={(e) =>
                        handleInputChange(
                          "Source",
                          formData.Source === "ManagementReview"
                            ? ""
                            : "ManagementReview"
                        )
                      }
                    />
                  }
                  label="Management Review"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Source === "OtherSource"}
                      onChange={(e) =>
                        handleInputChange(
                          "Source",
                          formData.Source === "OtherSource" ? "" : "OtherSource"
                        )
                      }
                    />
                  }
                  label="Other"
                />
              </Box>
            </Box>
          </Box>

          {/* Process Section checkboxes */}
          <Box display="flex" flexGrow={1}>
            <Box mr={4}>
              <Typography fontWeight="bold" lineHeight={2}>
                Process:
              </Typography>
              <Typography variant="body2">Check One</Typography>
            </Box>
            <Box
              display="grid"
              gridTemplateColumns="repeat(4, 1fr)"
              gap={2}
              flexGrow={1}
            >
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Process === "EstimatingSchedulingArt"}
                      onChange={(e) =>
                        handleInputChange(
                          "Process",
                          formData.Process === "EstimatingSchedulingArt"
                            ? ""
                            : "EstimatingSchedulingArt"
                        )
                      }
                    />
                  }
                  label=" Estimating, Scheduling, Art"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Process === "PrintingFinishing"}
                      onChange={(e) =>
                        handleInputChange(
                          "Process",
                          formData.Process === "PrintingFinishing"
                            ? ""
                            : "PrintingFinishing"
                        )
                      }
                    />
                  }
                  label="Printing & Finishing"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  sx={{
                    "& .MuiFormControlLabel-label": { fontSize: "14px" },
                  }}
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={
                        formData.Process === "PurchasingReceivingShipping"
                      }
                      onChange={(e) =>
                        handleInputChange(
                          "Process",
                          formData.Process === "PurchasingReceivingShipping"
                            ? ""
                            : "PurchasingReceivingShipping"
                        )
                      }
                    />
                  }
                  label=" Purchasing, Receiving, Shipping"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Process === "Otherprocess"}
                      onChange={(e) =>
                        handleInputChange(
                          "Process",
                          formData.Process === "Otherprocess"
                            ? ""
                            : "Otherprocess"
                        )
                      }
                    />
                  }
                  label="Other"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Process === "InstallationSource"}
                      onChange={(e) =>
                        handleInputChange(
                          "Process",
                          formData.Process === "InstallationSource"
                            ? ""
                            : "InstallationSource"
                        )
                      }
                    />
                  }
                  label="Installation"
                />
              </Box>
            </Box>
          </Box>

          {/* Priority Section checkboxes */}
          <Box display="flex" flexGrow={1}>
            <Box mr={4}>
              <Typography fontWeight="bold" lineHeight={2}>
                Priority:
              </Typography>
              <Typography variant="body2">Check One</Typography>
            </Box>
            <Box
              display="grid"
              gridTemplateColumns="repeat(4, 1fr)"
              gap={2}
              flexGrow={1}
            >
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Priority === "LowPriority"}
                      onChange={(e) =>
                        handleInputChange(
                          "Priority",
                          formData.Priority === "LowPriority"
                            ? ""
                            : "LowPriority"
                        )
                      }
                    />
                  }
                  label="Low"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Priority === "MediumPriority"}
                      onChange={(e) =>
                        handleInputChange(
                          "Priority",
                          formData.Priority === "MediumPriority"
                            ? ""
                            : "MediumPriority"
                        )
                      }
                    />
                  }
                  label="Medium"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Priority === "HighPriority"}
                      onChange={(e) =>
                        handleInputChange(
                          "Priority",
                          formData.Priority === "HighPriority"
                            ? ""
                            : "HighPriority"
                        )
                      }
                    />
                  }
                  label="High"
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Priority === "UrgentCritical"}
                      onChange={(e) =>
                        handleInputChange(
                          "Priority",
                          formData.Priority === "UrgentCritical"
                            ? ""
                            : "UrgentCritical"
                        )
                      }
                    />
                  }
                  label="Urgent / Critical"
                />
              </Box>
            </Box>
          </Box>

          {/* Problem Description */}
          <TextField
            sx={{
              "& .MuiInputBase-input": {
                color: "#000000",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#d3d3d3",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#4F46E5",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4F46E5",
              },
            }}
            label="Describe the issue or problem in detail"
            fullWidth
            size="small"
            multiline
            minRows={3}
            value={formData.Describe_the_issue_or_problem_in_detail || ""}
            onChange={(e) =>
              handleInputChange(
                "Describe_the_issue_or_problem_in_detail",
                e.target.value
              )
            }
          />

          <Box bgcolor="black" p={2} borderRadius={1}>
            <Typography fontWeight="bold" color="white">
              Assignee Information
            </Typography>
          </Box>

          <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2}>
            <TextField
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              label="Assigned To"
              fullWidth
              size="small"
              value={formData.assignedTo || ""}
              onChange={(e) => handleInputChange("assignedTo", e.target.value)}
            />
            <TextField
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              type="date"
              label="Date Assigned"
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
              value={formData.AssignedDate || ""}
              onChange={(e) =>
                handleInputChange("AssignedDate", e.target.value)
              }
            />
            <TextField
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              type="date"
              label="Respond By"
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
              value={formData.respondBy || ""}
              onChange={(e) => handleInputChange("respondBy", e.target.value)}
            />
          </Box>

          <Box bgcolor="black" p={2} borderRadius={1}>
            <Typography fontWeight="bold" color="white">
              Assignee Response
            </Typography>
          </Box>

          <TextField
            sx={{
              "& .MuiInputBase-input": {
                color: "#000000",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#d3d3d3",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#4F46E5",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4F46E5",
              },
            }}
            label="Containment / Immediate Corrections: (Required only for corrective action requests.)"
            fullWidth
            size="small"
            multiline
            minRows={2}
            value={formData.containment || ""}
            onChange={(e) => handleInputChange("containment", e.target.value)}
          />

          <TextField
            sx={{
              "& .MuiInputBase-input": {
                color: "#000000",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#d3d3d3",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#4F46E5",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4F46E5",
              },
            }}
            label="Root Cause of Problem:  (Required for all corrective and preventive issues; optional for suggestions for improvement.)"
            fullWidth
            size="small"
            multiline
            minRows={2}
            value={formData.rootCause || ""}
            onChange={(e) => handleInputChange("rootCause", e.target.value)}
          />

          <TextField
            sx={{
              "& .MuiInputBase-input": {
                color: "#000000",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#d3d3d3",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#4F46E5",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4F46E5",
              },
            }}
            label="Action Plan:  (Actions taken to eliminate root cause, resolve issue and prevent recurrence.)"
            fullWidth
            size="small"
            multiline
            minRows={2}
            value={formData.actionPlan || ""}
            onChange={(e) => handleInputChange("actionPlan", e.target.value)}
          />

          <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2}>
            <TextField
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              type="date"
              label="Date Action Completed"
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
              value={formData.actionCompleted || ""}
              onChange={(e) =>
                handleInputChange("actionCompleted", e.target.value)
              }
            />
            <TextField
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              label="Assignee Name"
              fullWidth
              size="small"
              value={formData.Assignee_Name || ""}
              onChange={(e) =>
                handleInputChange("Assignee_Name", e.target.value)
              }
            />
          </Box>

          <Box bgcolor="black" p={2} borderRadius={1}>
            <Typography fontWeight="bold" color="white">
              Verification
            </Typography>
          </Box>

          <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2}>
            <FormControl
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              fullWidth
              size="small"
              error={!!error.qualityOwner1}
            >
              <InputLabel>Verified By</InputLabel>
              <Select
                value={qualityOwner1 || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setQualityOwner1(value);
                  handleInputChange("qualityOwner1", value);
                }}
                label="Verified By"
              >
                <MenuItem value="" disabled>
                  Select User
                </MenuItem>
                {employees && employees.length > 0 ? (
                  employees.map((employee) => (
                    <MenuItem key={employee.ID} value={employee.ID}>
                      {employee.Name.zc_display_value}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    No User Found
                  </MenuItem>
                )}
              </Select>
              {error.qualityOwner1 && (
                <Typography variant="caption" color="error">
                  {error.qualityOwner1}
                </Typography>
              )}
            </FormControl>

            <TextField
              sx={{
                "& .MuiInputBase-input": {
                  color: "#000000",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d3d3d3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#4F46E5",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4F46E5",
                },
              }}
              type="date"
              label="Verified Date"
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
              value={formData.verifiedDate || ""}
              onChange={(e) =>
                handleInputChange("verifiedDate", e.target.value)
              }
            />
          </Box>

          <Box display="flex" alignItems="flex-start" gap={1}>
            <Box minWidth="135px">
              <Typography fontWeight="bold" lineHeight={3}>
                Result:
              </Typography>
            </Box>
            <Box display="flex" flexDirection="column" gap={0.5}>
              <Box display="flex" flexWrap="wrap" gap={1}>
                <FormControlLabel
                  sx={{ m: 0 }}
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Result === "PassResult"}
                      onChange={(e) =>
                        handleInputChange(
                          "Result",
                          formData.Result === "PassResult" ? "" : "PassResult"
                        )
                      }
                    />
                  }
                  label="Pass"
                />
                <FormControlLabel
                  sx={{ m: 0 }}
                  control={
                    <Checkbox
                      sx={{
                        color: "darkgray",
                        "&.Mui-checked": {
                          color: "#4F46E5",
                        },
                      }}
                      checked={formData.Result === "FailResult"}
                      onChange={(e) =>
                        handleInputChange(
                          "Result",
                          formData.Result === "FailResult" ? "" : "FailResult"
                        )
                      }
                    />
                  }
                  label="Fail: returned for further processing"
                />
              </Box>
            </Box>
          </Box>

          <TextField
            sx={{
              "& .MuiInputBase-input": {
                color: "#000000",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#d3d3d3",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#4F46E5",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4F46E5",
              },
            }}
            label="Notes / Comments"
            fullWidth
            size="small"
            multiline
            minRows={2}
            value={formData.notes || ""}
            onChange={(e) => handleInputChange("notes", e.target.value)}
          />
        </Box>

        <Box sx={{ pt: 5, pb: 2, justifyContent: "left" }}>
          <GlobalButton
            sx={{ mr: 1 }}
            icon={<SaveIcon />}
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? "Updating..." : "Update"}
          </GlobalButton>
          <GlobalButton
            icon={<CloseIcon />}
            onClick={() => onClose()}
            variant="outlined"
          >
            Cancel
          </GlobalButton>
        </Box>
      </DialogContent>

      {isSubmitting && <Loader message="Updating CAR record..." />}
    </Dialog>
  );
}
